import { render, staticRenderFns } from "./initialize.vue?vue&type=template&id=cae5d0d0&"
import script from "./initialize.vue?vue&type=script&lang=js&"
export * from "./initialize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports